import { withLDProvider } from 'launchdarkly-react-client-sdk';
import DesktopMasterLayout from './layouts/DesktopMasterLayout';

const App = (): JSX.Element => {
  const version = process.env.REACT_APP_VERSION;

  window.logger.info(`EYECUE Monitor v${version}`);

  return (
    <div className='theme-light'>
      <DesktopMasterLayout />
    </div>
  );
};

const launchdarklyContext = localStorage.getItem('launchdarkly.context');

export default withLDProvider({
  clientSideID: process.env.REACT_APP_LAUNCH_DARKLY_KEY ?? '',
  context: JSON.parse(launchdarklyContext ?? '{}'),
  options: { streaming: false },
})(App);
